export default __webpack_public_path__ + "static/media/dreadblight.0c79d9a2.png";